// static/js/menu/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import MainNavigationMenu from './MainNavigationMenu';

const rootElement = document.getElementById('navigation-root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MainNavigationMenu />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  console.error("No element with id 'navigation-root' found.");
}
